import { Injectable, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { mapSavedSearchResponse } from '@core/models/saved-search.mapper';
import { SavedSearchResponse } from '@core/models/saved-search.response';
import { SavedSearchState } from '@core/models/saved-search.state';
import { ApiService } from '@core/services/api.service';

import { CreateSavedSearchRequest, SavedSearchRepository } from './saved-search.repository';

@Injectable()
export class SavedSearchHttpRepository implements SavedSearchRepository {
  private readonly api = inject(ApiService);

  list(shopperId: number): Observable<SavedSearchState[]> {
    return this.api
      .get<SavedSearchResponse[]>(`shoppers/${shopperId}/saved-searches`)
      .pipe(map(items => items.map(mapSavedSearchResponse)));
  }

  create(shopperId: number, request: CreateSavedSearchRequest): Observable<SavedSearchState> {
    return this.api
      .post<SavedSearchResponse>(`shoppers/${shopperId}/saved-searches`, request)
      .pipe(map(mapSavedSearchResponse));
  }

  remove(shopperId: number, id: number): Observable<void> {
    return this.api.delete<void>(`shoppers/${shopperId}/saved-searches/${id}`);
  }

  markRun(shopperId: number, id: number): Observable<SavedSearchState | null> {
    return this.api
      .post<SavedSearchResponse>(`shoppers/${shopperId}/saved-searches/${id}/run`, {})
      .pipe(map(mapSavedSearchResponse));
  }
}
